<template>
    <div>
        <!-- <page-breadcrumb title="Graph" :routes="routes" /> -->
        <div class="flex items-center justify-between mb-4">
            <div v-if="breadcrumb != null">
                <div class="orgs" v-if="$route.name != 'report_occupancy'">
                    <ul class="brdcrmb">
                        <li v-if="isBreadCrumbSite"><router-link :to="breadcrumb.site.link">{{ breadcrumb.site.title
                        }}</router-link></li>
                        <li v-if="isBreadCrumbArea"><router-link :to="breadcrumb.area.link">{{ breadcrumb.area.title
                        }}</router-link></li>
                        <li v-if="isBreadCrumbCamera"><router-link :to="breadcrumb.camera.link">{{ breadcrumb.camera.title
                        }}</router-link></li>
                    </ul>
                </div>
            </div>
        </div>
        <vx-card>

            <div class="vx-row">
                <div class="vx-col mb-2" style="min-width:300px">
                    <v-select :disabled="disableSearch" label="name" placeholder="Select site" class="w-full" v-model="site"
                        :options="siteLists"></v-select>
                </div>
                <div class="vx-col mb-2" style="min-width:200px">
                    <v-select :disabled="disableSearch" placeholder="Select time range" class="w-full" v-model="timerange"
                        :options="timerangeLists"></v-select>
                </div>
                <div class="vx-col mb-2" v-if="!disableSearch">
                    <div class="flex items-center justify between">
                    <vs-button color="success" type="filled" icon-pack="feather" icon="icon-search"
                        @click.prevent="buildReport" class="mr-2">Build Report</vs-button>
                    <vs-button color="#67767f" type="filled" icon-pack="feather" icon="icon-refresh-cw"
                        @click.prevent="refreshData"></vs-button>
                    </div>
                </div>
            </div>

        </vx-card>

        <div class="mb-4">&nbsp;</div>

        <statistic-box v-if="showReport" :data="detail[0]" @downloadDailyReport="downloadCsvDailyReport"></statistic-box>

        <vx-card v-if="showReport">
            <div v-for="(chart, idx) in charts" :key="idx" class="vx-col w-full mb-8">
                <div class="title">{{ chart.name }}</div>
                <vue-apex-charts height="300" :options="chart.chartOptions" :series="chart.chart.series"></vue-apex-charts>
            </div>
        </vx-card>

        <vx-card v-else>
            <div class="flex flex-col items-center text-center">
                <img style="width:300px" src="@/assets/images/icon/icon-grafik.png" />
                <h3>Silahkan pilih site dan waktu</h3>
            </div>
        </vx-card>

        <div class="mb-4">&nbsp;</div>

        <vx-card v-if="showReport && showBottomLists">
            <report-bottom-lists :title="bottomTitle" :next="nextLink" :datas="statisticsData"></report-bottom-lists>
        </vx-card>

    </div>
</template>

<script>
import moment from 'moment';
import VueApexCharts from "vue-apexcharts";
import vSelect from "vue-select";
import DatePicker from 'vue2-datepicker';
import api from '@/api'
import dummyArea from './area.json';
import dummyCamera from './camera.json';
import dummyDetail from './detail.json';
import ReportBottomLists from "./components/ReportBottomLists.vue";
import StatisticBox from "./components/StatisticBox.vue";
import OccupancyChart from "./components/OccupancyChart.vue";
import CountingChart from "./components/CountingChart.vue";

import 'vue2-datepicker/index.css';

export default {
    data() {
        return {
            breadcrumb: null,
            daterange: '',
            site: '',
            event: '',
            detail: null,
            siteLists: [],
            timerange: { code: "1 hour", label: "1 hour" },
            timerangeLists: [
                { code: "1 hour", label: "1 hour" },
                { code: "3 hours", label: "3 hours" },
                { code: "6 hours", label: "6 hours" },
                { code: "12 hours", label: "12 hours" },
                { code: "24 hours", label: "24 hours" },
            ],
            dateSelected: { code: "today", label: "Today" },
            dateSelectLists: [
                { code: "today", label: "Today" },
                { code: "other", label: "Select Date" },
            ],
            disabledDateAfter: new Date(),
            showReport: false,
            statisticsData: [],
            bottomTitle: '',
            nextLink: '',
            isBreadCrumbSite: true,
            isBreadCrumbArea: true,
            isBreadCrumbCamera: true,
            disableSearch: false,
            showBottomLists: true,
            charts: [],
            chartModel: {},
            apiReportPath: '',
            apiChartPath: '',
            apiReportDetailPath: ''
        }
    },
    components: {
        DatePicker,
        vSelect,
        ReportBottomLists,
        StatisticBox,
        OccupancyChart,
        CountingChart,
        VueApexCharts
    },
    computed: {
        dummyArea() {
            return dummyArea
        },
        dummyCamera() {
            return dummyCamera
        },
        dummyDetail() {
            return dummyDetail
        }
    },
    beforeMount() {
        this.breadcrumb = JSON.parse(localStorage.getItem('reportBreadcrumb'));
        this.detail = this.dummyDetail.data
        this.checkRoute()
    },
    mounted() {
        this.getSiteLists()
        if(this.$route.name != 'report_occupancy') {
            this.getChartData()
            this.reportDetail()
            this.getReportData()
        }
    },
    methods: {
        refreshData() {
            if (this.showReport) {
            this.buildReport();
            } 
        },
        checkRoute() {
            const reportSearch = localStorage.getItem('reportSearch')
            const reportSearchParsed = JSON.parse(reportSearch)
            if (this.$route.name != 'report_occupancy') {
                this.showReport = true
                this.site = reportSearchParsed.site
                this.daterange = reportSearchParsed.daterange
                this.timerange = reportSearchParsed.timerange
                this.disableSearch = true
            }

            switch (this.$route.name) {
                case 'report_occupancy_area':
                    this.isBreadCrumbHome = true;
                    this.isBreadCrumbSite = true;
                    this.isBreadCrumbArea = true;
                    this.isBreadCrumbCamera = false;

                    this.bottomTitle = 'Camera'
                    this.nextLink = '/report_occupancy/camera'
                    this.apiReportPath = '/Avigilon/dashboard/area'
                    this.apiChartPath = '/Avigilon/dashboard/area/chart'
                    this.apiReportDetailPath = '/ReportDetail/area'
                    this.apiReportDetailCsv = '/ReportDetail/download/area'
                    this.reportModel = {
                        areaId: this.$route.params.id
                    }
                    this.chartModel = {
                        areaId: this.$route.params.id,
                        rangeParam: this.timerange.code
                    }
                    break;
                case 'report_occupancy_camera':
                    this.isBreadCrumbHome = true;
                    this.isBreadCrumbSite = true;
                    this.isBreadCrumbArea = true;
                    this.isBreadCrumbCamera = true;

                    this.showBottomLists = false
                    this.bottomTitle = ''
                    this.nextLink = ''
                    this.apiReportPath = '/Avigilon/dashboard/camera'
                    this.apiChartPath = '/Avigilon/dashboard/camera/chart'
                    this.apiReportDetailPath = '/ReportDetail/camera'
                    this.apiReportDetailCsv = '/ReportDetail/download/camera'
                    this.reportModel = {
                        cameraId: this.$route.params.id
                    }
                    this.chartModel = {
                        cameraId: this.$route.params.id,
                        rangeParam: this.timerange.code
                    }
                    break;
                default:
                    this.isBreadCrumbHome = true;
                    this.isBreadCrumbSite = true;
                    this.isBreadCrumbArea = false;
                    this.isBreadCrumbCamera = false;

                    this.bottomTitle = 'Area'
                    this.nextLink = '/report_occupancy/area'
                    this.apiReportPath = '/Avigilon/dashboard/site'
                    this.apiChartPath = '/Avigilon/dashboard/site/chart'
                    this.apiReportDetailPath = '/ReportDetail/site'
                    this.apiReportDetailCsv = '/ReportDetail/download/site'
            }
        },
        validBuildReport() {
            var error = 0
            if (this.site == '') {
                this.$vs.notify({
                    title: 'Error',
                    text: "Pilih site terlebih dahulu",
                    color: 'danger',
                    position: 'bottom-center'
                })
                error++
            }
            
            if (this.timerange == null || this.timerange == '') {
                this.$vs.notify({
                    title: 'Error',
                    text: "Pilih range waktu terlebih dahulu",
                    color: 'danger',
                    position: 'bottom-center'
                })
                error++
            }

            return error == 0
        },
        buildReport() {
            if (!this.validBuildReport()) {
                return
            }

            this.showReport = true
            const serachParams = {
                site: this.site,
                timerange: this.timerange,
            }

            localStorage.setItem('reportSearch', JSON.stringify(serachParams))

            this.$store.dispatch('updateSelectedSite', this.site)

            this.reportModel = {
                siteId: this.site.id,
            }
            this.chartModel = {
                siteId: this.site.id,
                rangeParam: this.timerange.code,
            }

            console.log(this.reportModel);
            console.log(this.chartModel);
            this.getChartData()
            this.reportDetail()
            this.getReportData()
        },
        notAferToday(date) {
            return date > new Date(new Date().setHours(23, 59, 0, 0));
        },
        openCustomReport() {
            this.$router.push('/custom_report')
        },
        getSiteLists() {
            if (this.$store.state.sites.length > 0) {
                this.siteLists = this.$store.state.sites
            } else {
                api.sites({
                    siteName: this.searchQuery
                })
                    .then(result => result.data)
                    .then(data => {
                        if (data.status) {
                            this.siteLists = data.data
                            this.$store.dispatch('updateSiteLists', data.data)
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                    });
            }
        },
        convertToCSV(objArray) {
          var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
          var str = '';

          for (var i = 0; i < array.length; i++) {
              var line = '';
              for (var index in array[i]) {
                  if (line != '') line += ','

                  line += array[i][index];
              }

              str += line + '\r\n';
          }

          return str;
        },
        exportCSVFile(headers, items, fileTitle) {
        if (headers) {
            items.unshift(headers);
        }

        // Convert Object to JSON
        var jsonObject = JSON.stringify(items);

        var csv = this.convertToCSV(jsonObject);

        var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, exportedFilenmae);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilenmae);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
        },
        downloadCsvDailyReport(params) {
            // GET /api/ReportDetail/download/site?siteId=3&startDate=2022-09-24&endDate=2022-09-26
            this.$vs.loading()

            const qParams = {
                ...this.reportModel,
                startDate: moment(params.start).format('YYYY-MM-DD'),
                endDate: moment(params.end).format('YYYY-MM-DD')
            }

            console.log(qParams)

            api.reportData(this.apiReportDetailCsv, qParams)
                .then(result => result.data)
                .then(data => {
                    let itemsFormatted = [];

                    let nameLabel = ''
                    if (this.apiReportDetailCsv.includes('site')) {
                        nameLabel = 'Site Name'
                    }
                    if (this.apiReportDetailCsv.includes('area')) {
                        nameLabel = 'Area Name'
                    }
                    if (this.apiReportDetailCsv.includes('camera')) {
                        nameLabel = 'Camera Name'
                    }

                    var headers = {
                        name: nameLabel,
                        inPersom: 'IN_Person',
                        inCar: 'IN_Car',
                        inMotor: 'IN_Motorcycle',
                        inOther: 'IN_OtherVehicle',
                        inTotal: 'Total_IN',
                        outPersom: 'OUT_Person',
                        outCar: 'OUT_Car',
                        outMotor: 'OUT_Motorcycle',
                        outOther: 'OUT_OtherVehicle',
                        outTotal: 'Total_OUT',
                        date: 'Date'
                    };

                    if (data.status) {
                        const rData = data.data

                        rData.forEach((item) => {
                            let name = ''
                            if (this.apiReportDetailCsv.includes('site')) {
                                name = item.siteName
                            }
                            if (this.apiReportDetailCsv.includes('area')) {
                                name = item.areaName
                            }
                            if (this.apiReportDetailCsv.includes('camera')) {
                                name = item.cameraName
                            }

                            itemsFormatted.push({
                                name: name.replace(/,/g, ''), // remove commas to avoid errors,
                                inPersom: item.inPerson,
                                inCar: item.inCar,
                                inMotor: item.inMotorcycle,
                                inOther: item.inOtherVehicle,
                                inTotal: item.totalIn,
                                outPersom: item.outPerson,
                                outCar: item.outCar,
                                outMotor: item.outMotorcycle,
                                outOther: item.outOtherVehicle,
                                outTotal: item.totalOut,
                                date: item.date
                            });
                        });

                        const now = Date.now();
                        var fileTitle = 'report-' + now; // or 'my-unique-title'

                        this.$vs.loading.close()
                        this.exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
                    }
                })
                .catch((e) => {
                    console.log(e)
                    this.$vs.loading.close()
                });
        },
        getChartData() {
            this.$vs.loading()
            api.reportData(this.apiChartPath, this.chartModel)
                .then((result) => result.data)
                .then((data) => {
                    if (data.status) {
                        this.charts = []
                        this.lists = data.data
                    }
                })
                .finally(() => {
                    if (this.lists.length > 0) {
                        this.buildChartData();
                    }
                })
                .catch((e) => {
                    console.log(e)
                    this.$vs.loading.close()
                });
        },
        buildChartData() {
            this.lists.map((x) => {
                const chart = {
                    ...x,
                    chartOptions: {
                        colors: ["#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
                        plotOptions: {
                            bar: {
                                horizontal: false,
                                endingShape: "rounded",
                                columnWidth: "20%",
                            },
                        },
                        dataLabels: {
                            enabled: false,
                        },
                        stroke: {
                            show: true,
                            width: 2,
                            colors: ["transparent"],
                        },
                        chart: {
                            stacked: true,
                            type: "bar",
                            toolbar: { show: false },
                        },
                        xaxis: {
                            categories: x.chart.categories,
                        },
                        yaxis: {
                            title: {
                                text: "Unit",
                            },
                        },
                        fill: {
                            opacity: 1,
                        },
                        tooltip: {
                            y: {
                                formatter: function (val) {
                                    return Math.abs(val);
                                },
                            },
                        },
                    },
                }
                this.charts.push(chart);
            });

            this.$vs.loading.close()
        },
        reportDetail() {
            api.reportData(this.apiReportDetailPath, this.reportModel)
                .then(result => result.data)
                .then(data => {
                    if (data.status) {
                        this.detail = data.data
                    }
                })
                .catch((e) => {
                    console.log(e)
                });
        },
        getReportData() {
            api.reportData(this.apiReportPath, this.reportModel)
                .then(result => result.data)
                .then(data => {
                    if (data.status) {
                        this.statisticsData = data.data
                    }
                })
                .catch((e) => {
                    console.log(e)
                });
        },
    }
}
</script>

<style lang="scss" scoped>
.orgs {
    font-size: 16px;

    span {
        color: #1372ac;
        font-weight: 600;
    }

    padding-bottom: 20px;
}

.title {
    text-align: center;
    font-size: 18pt;
    font-weight: 700;
}

.brdcrmb {
    text-transform: capitalize;
    font-weight: 600;
    display: flex;
    color: #1372AC;

    li {
        a {
            text-transform: capitalize;
            color: #1372AC;
            padding: 0 10px;

        }

        &:first-child {
            a {
                padding-left: 0 !important;
                padding-right: 10px;
            }
        }

        &::after {
            content: "/";
        }

        &:last-child {
            &::after {
                content: "";
            }
        }
    }
}
</style>